// extracted by mini-css-extract-plugin
export default {"container":"specific-stock_container__+4pah","deleteButton":"specific-stock_deleteButton__MLSq6","button":"specific-stock_button__DOlNv"};